import React from 'react';
import { Container } from '@fiverr-private/layout_components';
import { AppI18n } from '../../../../../i18n';

export const PhoneVerificationTitle = () => (
    <Container textAlign="center" maxWidth="500px">
        <AppI18n k="expert_card.activation.phone.title" />
    </Container>
);
